/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading, camelcase */
/**
 *  Do not edit this file! It is autogenerated from the harmony composer
 * 
 */

import React from 'react';
import PropTypes from 'prop-types';
import { useStore } from '@thd-nucleus/experience-context';
import { withDynamicImport } from '@thd-nucleus/app-render';
import { Skeleton, SkeletonBlock, SkeletonLine } from '@one-thd/sui-atomic-components';
import { useHydratedProps, withLayout, withLayoutAccordion, mergeProductClientOnlyProduct }
  from '@thd-olt-component-react/fusion-utils';

  

  import {
    RulesMiddleware as RulesMiddleware_MiddlewareSlot
  } from '@thd-olt-component-middleware/pip';



  import { withMagicApronTNT } from '@thd-olt-component-middleware/pip';






import { BotPrompt as BotPromptSSR } from '@thd-olt-component-react/magic-apron?clientSideRemove';

import { ProductOverviewAccordionBody as ProductOverviewAccordionBodySSR } from '@thd-olt-component-react/product-overview?clientSideRemove';

import { SpecificationsAccordionBody as SpecificationsAccordionBodySSR } from '@thd-olt-component-react/specifications?clientSideRemove';

import { QuestionsAndAnswersAccordionBody as QuestionsAndAnswersAccordionBodySSR } from '@thd-olt-component-react/questions-and-answers?clientSideRemove';

import { RatingsAndReviewsAccordionBody as RatingsAndReviewsAccordionBodySSR } from '@thd-olt-component-react/ratings-and-reviews?clientSideRemove';


const lazySlots = {};
const getPlaceholder = ({ skip }) => {
  if (skip) return null;
  return (
    <Skeleton>
      <SkeletonBlock />
      <SkeletonLine />
    </Skeleton>
  );
}

  

  

  

  

  

  

  

  

  

  

  

  

  

  

  

  

  

  

  

  

  

  

  

  

  

  

  

  

  

  

  

  
    

    
    
    
      
      
        
        
          const SlotG5Placeholder0 = null;
        
        
        const SlotG5Index0Client = () => {
          return import(
              '@thd-olt-component-react/magic-apron');
        }

        
        export const SlotG5Index0Load = withDynamicImport({
          server: () => {
            return BotPromptSSR;
          },
          client: SlotG5Index0Client,
          placeholder: SlotG5Placeholder0 || getPlaceholder({ skip: true }),
          name: 'BotPrompt',
        });

        
      
      

      
        let RulesMiddleware_MiddlewareSlot_SlotG5 = RulesMiddleware_MiddlewareSlot;
        
          
            RulesMiddleware_MiddlewareSlot_SlotG5 = withMagicApronTNT(RulesMiddleware_MiddlewareSlot_SlotG5, {"render":{"name":"fs-prop:magic-apron-qa-bot-render-placement","value":"above-accordion"}})
          
        
      


      
      
      lazySlots.LazySlotG5 = withLayout(
        
        [
        
          SlotG5Index0Load,
        
        ],
        
        
          RulesMiddleware_MiddlewareSlot_SlotG5
        ,
        
        [
        
        {
          waitForComponent: SlotG5Index0Client,
          placeholder: SlotG5Placeholder0 || getPlaceholder({ skip: true })
        },
        
        ]
      );
      


    



    
      
  

  
    

    
      
        
        
          
          
            const SlotG6Placeholder0K0 = null;
          

          
          const SlotG6Index0ClientK0 = () => {
            return import(
              '@thd-olt-component-react/product-overview');
          };
          
          export const SlotG6Index0LoadK0 = withDynamicImport({
            server: () => {
              return ProductOverviewAccordionBodySSR;
            },
            client: SlotG6Index0ClientK0,
            placeholder: SlotG6Placeholder0K0 || getPlaceholder({ skip: true }),
            name: 'ProductOverviewAccordionBody',
          });
          

          



          lazySlots.LazySlotG6KBody1 = withLayout(
            SlotG6Index0LoadK0,
            
              null
            ,
            {
              waitForComponent: SlotG6Index0ClientK0,
              placeholder: SlotG6Placeholder0K0 || getPlaceholder({ skip: true })
            }
          );     
        
        
      
      
        
        
          
          
            const SlotG6Placeholder1K0 = null;
          

          
          const SlotG6Index1ClientK0 = () => {
            return import(
              '@thd-olt-component-react/specifications');
          };
          
          export const SlotG6Index1LoadK0 = withDynamicImport({
            server: () => {
              return SpecificationsAccordionBodySSR;
            },
            client: SlotG6Index1ClientK0,
            placeholder: SlotG6Placeholder1K0 || getPlaceholder({ skip: true }),
            name: 'SpecificationsAccordionBody',
          });
          

          



          lazySlots.LazySlotG6KBody2 = withLayout(
            SlotG6Index1LoadK0,
            
              null
            ,
            {
              waitForComponent: SlotG6Index1ClientK0,
              placeholder: SlotG6Placeholder1K0 || getPlaceholder({ skip: true })
            }
          );     
        
        
      
      
        
        
          
          
            const SlotG6Placeholder2K0 = null;
          

          
          const SlotG6Index2ClientK0 = () => {
            return import(
              '@thd-olt-component-react/questions-and-answers');
          };
          
          export const SlotG6Index2LoadK0 = withDynamicImport({
            server: () => {
              return QuestionsAndAnswersAccordionBodySSR;
            },
            client: SlotG6Index2ClientK0,
            placeholder: SlotG6Placeholder2K0 || getPlaceholder({ skip: true }),
            name: 'QuestionsAndAnswersAccordionBody',
          });
          

          



          lazySlots.LazySlotG6KBody3 = withLayout(
            SlotG6Index2LoadK0,
            
              null
            ,
            {
              waitForComponent: SlotG6Index2ClientK0,
              placeholder: SlotG6Placeholder2K0 || getPlaceholder({ skip: true })
            }
          );     
        
        
      
      
        
        
          
          
            const SlotG6Placeholder3K0 = null;
          

          
          const SlotG6Index3ClientK0 = () => {
            return import(
              '@thd-olt-component-react/ratings-and-reviews');
          };
          
          export const SlotG6Index3LoadK0 = withDynamicImport({
            server: () => {
              return RatingsAndReviewsAccordionBodySSR;
            },
            client: SlotG6Index3ClientK0,
            placeholder: SlotG6Placeholder3K0 || getPlaceholder({ skip: true }),
            name: 'RatingsAndReviewsAccordionBody',
          });
          

          



          lazySlots.LazySlotG6KBody4 = withLayout(
            SlotG6Index3LoadK0,
            
              null
            ,
            {
              waitForComponent: SlotG6Index3ClientK0,
              placeholder: SlotG6Placeholder3K0 || getPlaceholder({ skip: true })
            }
          );     
        
        
      
      
    
    
    
    



    
    
      
      
        
          import { ProductOverviewAccordionTitle as ProductOverviewAccordionTitleSlotG6Index0K0Header }
            from '@thd-olt-component-react/product-overview';
          
      
        
          import { SpecificationsAccordionTitle as SpecificationsAccordionTitleSlotG6Index1K0Header }
            from '@thd-olt-component-react/specifications';
          
      
        
          import { QuestionsAndAnswersAccordionTitle as QuestionsAndAnswersAccordionTitleSlotG6Index2K0Header }
            from '@thd-olt-component-react/questions-and-answers';
          
      
        
          import { RatingsAndReviewsAccordionTitle as RatingsAndReviewsAccordionTitleSlotG6Index3K0Header }
            from '@thd-olt-component-react/ratings-and-reviews';
          
        

      

      
        
            
        
      
        
            
        
      
        
            
        
      
        
            
        
      

      const LazySlotG6Accordion = withLayoutAccordion([
        [
        
          [
          
            withLayout(
              ProductOverviewAccordionTitleSlotG6Index0K0Header,
              
            ),
          
          ],
        
          [
          
            withLayout(
              SpecificationsAccordionTitleSlotG6Index1K0Header,
              
            ),
          
          ],
        
          [
          
            withLayout(
              QuestionsAndAnswersAccordionTitleSlotG6Index2K0Header,
              
            ),
          
          ],
        
          [
          
            withLayout(
              RatingsAndReviewsAccordionTitleSlotG6Index3K0Header,
              
            ),
          
          ],
        
        ],
        [
        
          [
          
            lazySlots.LazySlotG6KBody1,
          
          ],
        
          [
          
            lazySlots.LazySlotG6KBody2,
          
          ],
        
          [
          
            lazySlots.LazySlotG6KBody3,
          
          ],
        
          [
          
            lazySlots.LazySlotG6KBody4,
          
          ],
        
        ]
      ],
      
        null
      )
      
  

  
    

    
    
    
      
      
        
        
          const SlotG7Placeholder0 = null;
        
        
        const SlotG7Index0Client = () => {
          return import(
              '@thd-olt-component-react/magic-apron');
        }

        
        export const SlotG7Index0Load = withDynamicImport({
          server: () => {
            return BotPromptSSR;
          },
          client: SlotG7Index0Client,
          placeholder: SlotG7Placeholder0 || getPlaceholder({ skip: true }),
          name: 'BotPrompt',
        });

        
      
      

      
        let RulesMiddleware_MiddlewareSlot_SlotG7 = RulesMiddleware_MiddlewareSlot;
        
          
            RulesMiddleware_MiddlewareSlot_SlotG7 = withMagicApronTNT(RulesMiddleware_MiddlewareSlot_SlotG7, {"render":{"name":"fs-prop:magic-apron-qa-bot-render-placement","value":"default","default":true}})
          
        
      


      
      
      lazySlots.LazySlotG7 = withLayout(
        
        [
        
          SlotG7Index0Load,
        
        ],
        
        
          RulesMiddleware_MiddlewareSlot_SlotG7
        ,
        
        [
        
        {
          waitForComponent: SlotG7Index0Client,
          placeholder: SlotG7Placeholder0 || getPlaceholder({ skip: true })
        },
        
        ]
      );
      


    



    
      
  

  

  

  

  

  

  

  

  

  

  

  

  

  

  

  

  

  

  

  

  

  



// to be generated by ejs based on config
export const DynamicImporter = (props) => {
  const { storeId, storeZip } = useStore();
  const slot = props.config.slots[props.slot];
  const components = slot.isAccordion
    ? slot.components.flat().map((sc) => sc.components).flat()
    : slot.components.flat();

  // todo use merge option?
  const hydratedProps = useHydratedProps(components, { itemId: props.itemId });
    components.forEach((com, index) => {
      // eslint-disable-next-line no-param-reassign
      com.props = hydratedProps[index]
    });

  const merge = mergeProductClientOnlyProduct;

  // use this for debugging, attache to queryProvider prop

  // const queryOptions = ({ options, queryName }) => {
  //   return {
  //     ...options,
  //     fetchPolicy: 'cache-only'
  //   };
  // };

  const ssr = typeof window === 'undefined';
  const decisionIndex = ssr
    ? 0
    : Number(
        (window.__SLOT_DECISIONS__ && window.__SLOT_DECISIONS__[props.slot]) ?? "0"
      );

  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
      if (props.slot === 'SlotG5') {
      
        
          
          return (
            <lazySlots.LazySlotG5
              {...props}
              {...hydratedProps[0]}
              config={props.config}
              fusionSlotName="SlotG5"
              fusionComponentName="@thd-olt-component-react/magic-apron"
              version="7.5.0"
            />
          );
        
        
      }
    
  
    
      if (props.slot === 'SlotG6') {
      
        return (
          <LazySlotG6Accordion
            {...props}
            config={props.config}
            fusionSlotName="SlotG6"
            fusionComponentName="accordion"
            fusionClassName={slot.fusionClassName}
            isDynamic
            // commenting inner query provider since withDynamicImport already wraps AccordionBody with inner query provider
            // queryProvider={{
            //   inherit: 'page',
            //   merge,
            //   queryOptions,
            //   cache key for all accordions must be the same
            //   otherwise a race condition will occur generating duplicate requests
            //   cacheKey: 'page',
            //   defaultVariables: props?.qctx?.defaultVariables?.current || { storeId, zipCode: storeZip }
            // }}
          />
        );
        
      }
    
  
    
      if (props.slot === 'SlotG7') {
      
        
          
          return (
            <lazySlots.LazySlotG7
              {...props}
              {...hydratedProps[0]}
              config={props.config}
              fusionSlotName="SlotG7"
              fusionComponentName="@thd-olt-component-react/magic-apron"
              version="7.5.0"
            />
          );
        
        
      }
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  


  return null;
};

DynamicImporter.propTypes = {
  config: PropTypes.shape({
    slots: PropTypes.shape({})
  }).isRequired,
  slot: PropTypes.string.isRequired,
};